<div class="ui-g ui-fluid">
  <p-toast ></p-toast>
  <div class="ui-g-12 ui-md-12 ui-lg-12 background">
    <div class="ui-g-6 ui-md-2 ui-lg-2 p-text-left">
      <h2 class="title">Perfil</h2>
    </div>
    <div class="ui-g-2 ui-md-3 ui-lg-3">
      <div class="avatar" style="margin: 0;" [style.background]="'url(' + urlImage + ')'"></div>
    </div>
  </div>
  <div class="ui-g-12 ui-md-10 ui-lg-8 " style="display: block; align-items: center; margin: 2% auto;">
    <div class="ui-g-12">
      <p-selectButton [options]="types" (onOptionClick)="test($event)" [(ngModel)]="selectedType"></p-selectButton>
      <div *ngIf="selectedType == 0; then insured else dependent"></div>
    </div>
      <ng-template #insured>
        <div class="ui-g-12 cardGray">
        <div class="ui-g-12 " (click)="getCoupons()" *ngIf="!env.usrHN">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class="cardBorder2 ui-g-12" style="padding: 0;">
                <div class="ui-g-2"> <i class="pi pi-ticket icon"></i></div>
                <div class="ui-g-10">
                  <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_cupons_available')}}</h4>-->
                  <h4 style="font-weight: 400;">Descuento de consultas disponibles:</h4>
                </div>
              </div>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4" >
              <button pButton type="button" label="Visualizar"></button>
            </div>
        </div>
        <div class="ui-g-12" (click)="getCard(user.showOldCardNumber, user)">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class="cardBorder2 ui-g-12" style="padding: 0;">
                <div class="ui-g-2"><i class="pi pi-id-card icon"></i></div>
                <div class="ui-g-10">
                  <h4 style="font-weight: 400;">Carné digital:</h4>
                </div>
              </div>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <button pButton type="button" label="Visualizar" ></button>
            </div>
        </div>
        <div class="ui-g-12 carne-digital noMg" style="padding-bottom: 0;">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12 noMg">
              <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_state_insured')}}</h4>-->
              <h4 class="noMg" style="font-weight: 400;">Estado del asegurado:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class=" card ui-g-12 noMg">
              <h4 >{{user.policyHolderStatus}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12 noMg" >
              <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_card_number_label')}}</h4>-->
              <h4 style="font-weight: 400;">Número de carné o empleado:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12 noMg">
              <ng-container *ngIf="user.showOldCardNumber == true; then second else first"></ng-container>
              <ng-template #first><h4 >{{user.policyHolderCompleteCardNumber}}</h4></ng-template>
              <ng-template #second><h4 >{{user.policyHolderCompleteCardNumberOld}}</h4></ng-template>
            </div>
          </div>
        </div>
        <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
            <div class="ui-g-12 ui-md-6 ui-lg-6 noMg">
              <div class="card ui-g-12 noMg" >
                <!--<h4 style="font-weight: 400; color: #073c8f; ">{{this.fbase.getStringRC('global_name_insure')}}</h4>-->
                <h4 style="font-weight: 400;">Nombre:</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6 noMg">
              <div class="card ui-g-12 noMg">
                <h4 style="margin: 0;">{{user.policyHolderCompleteName}}</h4>
              </div>
            </div>
        </div>
        <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
            <div class="ui-g-12 ui-md-6 ui-lg-6 noMg">
              <div class="card ui-g-12 noMg" >
                <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_company_name')}}</h4>-->
                <h4 style="font-weight: 400;">Nombre de la empresa:</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6 noMg">
              <div class="card ui-g-12 noMg">
                <h4>{{user.companyName}}</h4>
              </div> 
            </div>
        </div>
        <!--<div class="ui-g-12">
          <div class="card ui-g-12">
            <div class="ui-g-6 ui-md-12 ui-sm-12">
              <h4 style="font-weight: 400;">{{this.fbase.getStringRC('global_birthday_label')}}</h4>
            </div>
            <div class="ui-g-6 ui-md-12 ui-sm-12">
              <h2>{{user.birthdate}}</h2>
            </div>
          </div>
        </div>-->
        <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
            <div class="ui-g-12 ui-md-6 ui-lg-6" style="margin: 0;">
              <div class="card ui-g-12"  style="margin: 0;">
                <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_policy')}}</h4>-->
                <h4 style="font-weight: 400;">Póliza:</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6"  style="margin: 0;">
              <div class="card ui-g-12"  style="margin: 0;">
                <h4 style="margin: 0;">{{user.policy}}</h4>
              </div>
            </div>
        </div>
        <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
            <div class="ui-g-12 ui-md-6 ui-lg-6" style="margin: 0;">
              <div class="card ui-g-12" style="margin: 0;">
                <!--<h4 style="font-weight: 400; color: #073c8f;">{{this.fbase.getStringRC('global_policy_certificate')}}</h4>-->
                <h4 style="font-weight: 400;">Póliza / certificado:</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6" style="margin: 0;">
              <div class="card ui-g-12" style="margin: 0;">
                <h4 style="margin: 0;">{{user.certificate}}</h4>
              </div>
            </div>
        </div>
      </div>
      </ng-template>
      <ng-template #dependent>
        <div class="cardGray ui-g-12">
        <div *ngIf="user.dependents.length >1">
          <div *ngFor="let dependent of user.dependents; let i = index">
            <div *ngIf="i > 0">
              <div *ngIf="!isCMI" class="ui-g-12 ui-md-6 ui-lg-6" (click)="getCard(user.showOldCardNumber, dependent)">
                  <div class=" cardBorder2 ui-g-12" style="padding: 0;">
                    <div class="ui-g-2"><i class="pi pi-id-card icon"></i></div>
                    <div class="ui-g-10">
                      <h4 style="font-weight: 400;">Carné digital:</h4>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <button pButton type="button" label="Visualizar" class="p-button"></button>
                  </div>
              </div>
              <div *ngIf="isCMI" class="ui-g-12 ui-md-6 ui-lg-6" (click)="getCard(user.showOldCardNumber, user)">
                <div class=" cardBorder2 ui-g-12" style="padding: 0;">
                  <div class="ui-g-2"><i class="pi pi-id-card icon"></i></div>
                  <div class="ui-g-10">
                    <h4 style="font-weight: 400;">Carné digital:</h4>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <button pButton type="button" label="Visualizar" class="p-button"></button>
                </div>
            </div>
              <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
                  <div class="ui-g-12 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12 noMg">
                      <h4 style="font-weight: 400;">Número de carné o empleado:</h4>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12 noMg">
                      <div *ngIf="isCMI">
                        <h2>{{user.policyHolderCompleteCardNumberOld}}</h2>
                      </div>
                      <div *ngIf="!isCMI">
                        <ng-container *ngIf="user.showOldCardNumber == true; then secondd else firstd"></ng-container>
                        <ng-template #firstd><h2>{{dependent.policyHolderCompleteCardNumber}}</h2></ng-template>
                        <ng-template #secondd><h2>{{dependent.policyHolderCompleteCardNumberOld}}</h2></ng-template>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="ui-g-12" style="margin: 0; padding-bottom: 0;">
                  <div class="ui-g-12 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12 noMg">
                      <h4 style="font-weight: 400;">Nombre:</h4>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12 noMg">
                      <h4 style="margin: 0;">{{dependent.policyHolderCompleteName}}</h4>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="user.dependents.length == 1">
            <div class="ui-g-12" style="text-align: center;">
              <div class="card">
                <h4 style="font-weight: 400;">No posee dependientes.</h4>
              </div>
            </div>
        </div>
      </div>
      </ng-template>
    </div>
    <!--<h3>DEPENDIENTES</h3>
    <ul *ngFor="let dependent of user.dependents; let i = index">
      <li>
        <span>{{dependent.dependentNumber}}</span>
      </li>
      <li>
        <p>{{this.fbase.getStringRC('global_name_insure')}}</p>
        <h2>{{dependent.policyHolderCompleteName}}</h2>
      </li>
      <li>
        <p>{{this.fbase.getStringRC('global_card_number_label')}}</p>
        <ng-container *ngIf="user.showOldCardNumber == true; then firstd else secondd"></ng-container>
        <ng-template #firstd><h2>{{dependent.policyHolderCompleteCardNumber}}</h2></ng-template>
        <ng-template #secondd><h2>{{dependent.policyHolderCompleteCardNumberOld}}</h2></ng-template>
      </li>
      <li>
        <p>{{this.fbase.getStringRC('global_birthday_label')}}</p>
        <h2>{{dependent.birthdate}}</h2>
      </li>
    </ul>
    <div>
    <h3>
      CUPONES
    <div>
      <h1>Carne Digital</h1>
      <app-ngui-in-view>
        <img *ngIf src="{{frontUrl.front }}" alt="" height="33%">
      </app-ngui-in-view>
      <app-ngui-in-view>
        <img *ngIf src="{{frontUrl.back }}" alt="" height="33%">
      </app-ngui-in-view>
    </div>-->
    <p-dialog [(visible)]="showCoupons" (close)="showCoupons=false" [closable]="true" [style]="{width: '70vw'}">
      <div class="ui-g-12">
        <div class="cardGray ui-g-12">
          <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="coupons">
            <div class="ui-g-12">
              <div class="card background">
                <p class="subTitleW">Cupones de consultas disponibles</p>
              </div>
            </div>
            <!--<div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">TIpo:</h4>
                <p class="number">{{coupons.limitType}}</p>
              </div>
            </div>-->
            <div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">Limite:</h4>
                <p class="number"> {{coupons.couponsLimit}}</p>
              </div>
            </div>
            <div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">Usados:</h4>
                <p class="number"> {{coupons.couponsUsed}}</p>
              </div>
            </div>
            <div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">Disponibles:</h4>
                <p class="number">{{coupons.couponsAvailable}}</p>
              </div>
            </div>
            <div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">Certificado:</h4>
                <p class="number">{{coupons.certificate}}</p>
              </div>
            </div>
            <div class="ui-lg-4 ui-md-4 ui-g-12">
              <div class="card ui-g-12">
                <h4 class="info">Miembros:</h4>
                <p class="number"> {{coupons.certificateMembers}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-dialog>
  </div>

